import React from 'react'
import SocialBadgeForm from './form'

export default function ChallengeAdd (props) {
  const data = {}

  return (
    <SocialBadgeForm data={data} {...props} />
  )
}
